import { useViewport } from 'components/general/useViewPort';
import React, { useMemo } from "react";
import Competitor from 'components/presentation/Competitor';
import { NocMemo as Noc } from 'components/presentation/Noc';
import Label from "components/general/Label"
import { ColumnNameH2H, ColumnBib } from "components/common/TableColumns"
import MirsTable from "components/general/table/Table";
import { capitalizeFirstLetter } from 'helpers/utils'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const TableColumns = () => {
  return (
    [
      ColumnBib({ disableSort: true, label: 'HeaderNumber', headerClassName: 'text-end w-10' }),
      ColumnNameH2H({ showCaptainAbbr: true, showSuspendedCode: true, hideNoc: true }),
      ColumnPosition({}),
    ]
  )
}

export function ColumnPosition({
  disableSort = true,
  className = 'text-start',
  headerClassName = 'text-start w-10',
  label = 'HeaderPosition',
  code = 'Position'
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'functionDescription',
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort,
      id: code
    }
  )
}

const getConfiguration = (data, breakPoint, mirs_discipline) => {
  let configuration = {
    columns: [],
    subComponent: null,
    caption: null,
    hiddenColumns: [],
    sortBy: [],
    configs: {
    }
  };

  configuration.captionStarters = (
    <div className="d-flex justify-content-between">
      <div className='d-flex align-items-center'>
        <div className='d-none d-md-block me-1'>
          <Noc className='me-1' {...data?.participant?.organisation} />
        </div>
        <strong>
          <Competitor hidePicture={true} {...data?.participant} />
        </strong>
      </div>
      <div>
        <Jersey data={data} />
      </div>
    </div>
  )
  configuration.columns = TableColumns();

  configuration.captionSubstitutes = (

    <div className='d-flex align-items-center'>
      <div className='d-none d-md-block me-8'>
        <Label data="HeaderReplacements" sport={mirs_discipline} />
      </div>
    </div>
  )

  return configuration;
}

const Jersey = ({ data }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters();
  const uniform = capitalizeFirstLetter(data?.eventUnitEntries?.find(i => i?.eue_code === 'UNIFORM')?.eue_value?.toLowerCase());
  return (
    <>
      <div>
        <Label data={uniform} sport={mirs_discipline} />
      </div>
    </>
  )
}

const StartListSide = ({ data, resultStatus, config, date }) => {
  const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters();
  const { breakPoint } = useViewport();

  const configEvent = useMemo(() => getConfiguration(data, breakPoint, mirs_discipline));

  return (<>
    {data.teamAthletes && (
      <div className="start-list-side-main">
        <div className="row">
          <div className="col-12">
            <MirsTable
              id={`mirs-table-start-list-starters-${mirs_rsc}-${data?.participant?.code}`}
              data={data?.teamAthletes}
              columns={configEvent.columns}
              keyRow='athlete-code'
              caption={configEvent.captionStarters}
              initialSortBy={configEvent.sortBy}
            />
          </div>          
        </div>
      </div>
    )
    }
  </>)
}

export default StartListSide;
